import { createAction } from '@reduxjs/toolkit';

export const SEND_MESSAGE_ACTION_TYPE = 'saga/sendMessage';
export const sendMessageAction = createAction(SEND_MESSAGE_ACTION_TYPE);
